import React from 'react';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import { generatePath, Link, Route } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from '@mui/styles';
import RouteConstants from '../../constants/routeConstants';
import { useThemeState } from '../../hookState/ThemeState';
import Helper from '../../utility/helper';
import { withRouter } from 'react-router-dom';

const theme = createTheme();
const useStyles = makeStyles(() => ({
    nopointer: {
        textDecoration: 'none',
        [theme.breakpoints.down(900)]: {
            margin: 1,
            borderRadius: '16px',
            background: ' #EEEEEE',
        },
    },
    backColor: {
        background: '#ccc',
        '&:hover': {
            background: '#ccc',
        },
    },
}));

function ModuleDrawer(props) {
    // console.log("props",props);
    const classes = useStyles();
    const themeState = useThemeState();
    const eventInfo = Helper.getStorage('eventInfo');
    return (
        <>
            {eventInfo ?
                <Box id='moduleDrawer'
                    sx={{
                        height: '100%',
                        color: 'fff',
                        fontWeight: '500',
                        width: { xs: '100%', sm: '100%', md: 125 },
                        '.MuiSvgIcon-root': { fill: themeState.leftnav.value },
                        maxHeight: 'calc(100vh - 70px)',
                        backgroundColor: '#f3f5fa',
                    }}>
                    <List
                        sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'row',
                                sm: 'row',
                                md: 'column',
                            },
                            width: '100%',
                            flexWrap: 'wrap',
                        }}
                        component="nav">
                        <Route>
                            <Link
                                to={generatePath(RouteConstants.MODULE, { 'eventID': eventInfo.eventID })}
                                className={classes.nopointer}>
                                <ListItemButton className={
                                    Helper.getURLSlug() ===
                                        "module"
                                        ? classes.backColor
                                        : ''
                                }>
                                    <ListItemText primary="Event Module" />
                                </ListItemButton>
                            </Link>

                            {props &&
                                props.modules.length > 0 &&
                                props.modules.map((module, key) => {
                                    // console.log("module.moduleName",module);
                                    if (module.moduleID !== 15 && module.moduleID !== 24) {
                                        return (
                                            <Link
                                                key={key}
                                                to={{
                                                    pathname: generatePath(RouteConstants.MODULE_NAME, { 'eventID': eventInfo.eventID, 'moduleName': module.moduleName.toLowerCase() }),
                                                    state: { displayName: module.displayName }
                                                }}
                                                className={classes.nopointer}>
                                                <ListItemButton className={
                                                    Helper.getURLSlug() ===
                                                        module.moduleName.toLowerCase()
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                    <ListItemText
                                                        // primary={module.moduleName.toLowerCase().indexOf('registration') > -1 ? 'Registration' : module.displayName}
                                                        primary={module.displayName}

                                                    />
                                                </ListItemButton>
                                            </Link>
                                        );
                                    }
                                })}
                        </Route>
                    </List>
                </Box>
                : null}
        </>
    );
}
export default withRouter(ModuleDrawer);

